// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import * as React from 'react';
/**
 * A tsx component for a set of items logically grouped together.
 */
export function GroupItem(props) {
    const { spacing, children, className, ...rest } = props;
    // Filter out null or undefined children for clean rendering.
    const validChildren = React.Children.toArray(children).filter(Boolean);
    const numChildren = validChildren.length;
    return (React.createElement("div", { className: `jp-StatusBar-GroupItem ${className || ''}`, ...rest }, validChildren.map((child, i) => {
        const key = `group-item-${i}`;
        if (i === 0) {
            return (React.createElement("div", { key: key, style: { marginRight: `${spacing}px` } }, child));
        }
        else if (i === numChildren - 1) {
            return (React.createElement("div", { key: key, style: { marginLeft: `${spacing}px` } }, child));
        }
        else {
            return (React.createElement("div", { key: key, style: { margin: `0px ${spacing}px` } }, child));
        }
    })));
}
//# sourceMappingURL=group.js.map